import React, { Component } from 'react';


class Policy extends Component {
    state = {
        isActive: false,
        windowHeight: window.innerHeight - 60,
    };





    // the display
    handleOutsideClick = (event) => {
        if (this.node && !this.node.contains(event.target)) {
            this.setState({ isActive: false, });
            const formdisplay = document.querySelector(".dash_add_course_cover.policy")
            formdisplay.style.display = "none"
        }

    };
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }
    handleResize = () => {
        this.setState({ windowHeight: window.innerHeight - 60 });
    };


    render() {

        const { onResize } = this.props;

        return (

            <div className="dash_add_course_cover policy" style={{ width: `calc(100% - ${onResize}px - 3px)`, height: this.state.windowHeight }}>
                <div className="dash_form_container" ref={(node) => (this.node = node)}>
                    <h2>Privacy Policy</h2>
                    {/* <p>Welcome to Geoinfotech Academy. Your privacy is important to us, and we are committed to protecting your personal information.
                        This Privacy Policy explains how we collect, use, and share information when you use our platform.<br />
                        1. Information We Collect<br />
                        We collect the following types of information:<br />
                        a. Personal Information<br />
                        When you register on our platform, enroll in a course, or make a payment, we may collect:<br />
                        <li>Full Name</li>
                        <li>Email Address</li>
                        <li>Phone Number</li>
                        <li>Payment Details (processed securely via a third-party payment provider)</li>
                        b. Usage Data<br />
                        We collect data about how you interact with our platform, including:<br />
                        <li>Course progress and completion</li>
                        <li>Pages visited and features used</li>
                        <li>Device information (IP address, browser type, etc.)</li>
                        c. Cookies and Tracking Technologies<br />
                        We use cookies and similar technologies to enhance your user experience,
                        analyze trends, and administer the platform. You can control cookie settings
                        in your browser.<br />
                        2. How We Use Your Information<br />
                        We use the information collected for the following purposes:<br />
                        <li>To provide and improve our educational services</li>
                        <li>To process payments and manage subscriptions</li>
                        <li>To personalize user experience and recommend courses</li>
                        <li>To ensure security and prevent fraud</li>
                        <li>To communicate with you regarding updates, promotions, and support</li>
                        3. How We Share Your Information<br />
                        We do not sell or rent your personal information. However, we may share it with:<br />
                        Service Providers: Third-party providers who help us process payments, host data, and deliver services.<br />
                        Legal Compliance: If required by law, we may disclose information to comply with legal obligations.<br />
                        4. Data Security<br />
                        We implement strict security measures to protect your personal data. However,
                        no system is completely secure, and we cannot guarantee absolute security.<br />
                        5. Your Rights and Choices<br />
                        You have the right to:<br />
                        Access, update, or delete your personal data<br />
                        6. Third-Party Links<br />
                        Our platform may contain links to third-party websites. We are not responsible for their privacy practices,
                        so please review their policies separately.<br />
                        7. Changes to This Policy<br />
                        We may update this Privacy Policy from time to time. Changes will be posted on this page
                        , and significant updates will be communicated via email or platform notifications.<br />
                        8. Contact Us<br/>
                        If you have any questions about this Privacy Policy, please contact us at:<br/>
                    </p> */}
                    <p>At Geoinfotech, we are committed to protecting your privacy and safeguarding your personal
                        information. This Privacy Policy outlines how we collect, use, disclose, and manage your data when
                        you
                        use our website and services</p>
                    <h3>Information We Collect</h3>
                    <p>- Personal Information: Name, email address, phone number, location, course interests, and payment
                        details.<br />
                        - Technical Data: IP address, browser type, operating system, device information, and usage
                        data.<br />
                        - Cookies & Tracking: We use cookies and similar technologies to enhance user experience and gather
                        analytics.</p>
                    <h3>How We Use Your Information</h3>
                    <p>
                        - To register you for courses and communicate updates.<br />
                        - To process payments and provide support.<br />
                        - To improve our content, website, and services.<br />
                        - For legal compliance and fraud prevention.
                    </p>
                    <h3>Sharing of Information</h3>
                    <p>
                        We do not sell your personal data. We may share data with:<br />
                        - Trusted service providers (e.g., payment processors, cloud storage).<br />
                        - Government or law enforcement (only if legally required).<br />
                        - Affiliates or partners with your consent.
                    </p>
                    <h3>Your Rights</h3>
                    <p>
                        - Access, correction, or deletion of personal data.<br />
                        - Opt-out of marketing emails at any time.<br />
                        - Request data portability or restriction of processing.
                    </p>
                    <h3>Data Security</h3>
                    <p>
                        We implement appropriate technical and organizational measures to protect your data from
                        unauthorized access, loss, or misuse.
                    </p>
                    <h3>Contact</h3>
                    <p>
                        For questions or concerns regarding your privacy:<br />
                        Email: mail@geoinfotech.ng<br />
                        Phone: 07070708909
                    </p>
                </div>
            </div>


        );
    }
}

export default Policy;